<template>
  <b-card>
    <avito-city-form/>  
  </b-card>
</template>

<script>
import AvitoCityForm from "@/components/AvitoCityForm";

export default {
  name: "AvitoCityAdd",
  components: {AvitoCityForm}
}
</script>
